
const ORGANIZATION_WEB_API_SERVER = process.env.VUE_APP_WEB_API;

const SERVICE_IP_PORT = process.env.VUE_APP_SERVICE_IP_PORT;

const RESOURCE_IP_PORT = process.env.VUE_APP_RESOURCE_IP_PORT;

const ATHUB_CLOUD_SERVER = process.env.VUE_APP_SERVICE_IP_PORT;

const BASEPATH = process.env.VUE_APP_BASEPATH;

const EQUIPMENT_IN_OUT_SERVER = process.env.VUE_APP_REGISTER_SERVER;

const KPI_SERVER = process.env.VUE_APP_KPI_SERVER;

const ASSESSMENT_SERVER = process.env.VUE_APP_ASSESSMENT_SERVER;

const ATTACHMENT_SERVER = process.env.VUE_APP_ATTACHMENT_SERVER;

const COMPANY_SERVER=process.env.VUE_APP_COMPANY_SERVER;

const DOMAINALN_SERVER=process.env.VUE_APP_DOMAINALN_SERVER;

const PUE_SERVER=process.env.VUE_APP_PUE_IP_PORT;
const BILLING_SERVER=process.env.VUE_APP_BILLING_SERVER;

const AUTOKEY_SERVER = process.env.VUE_APP_AUTOKEY_SERVER;

const WORK_ORDER_SERVER = process.env.VUE_APP_WORKORDER_SERVER;

const KNOWLEDGE_SERVER = process.env.VUE_APP_KNOWLEDGE_SERVER;

const PERSON_SERVER = process.env.VUE_APP_PERSON_SERVER;
const ASSET_SERVER = process.env.VUE_APP_ASSET_SERVER;

const REVIEW_SERVER = process.env.VUE_APP_REVIEW_SERVER;
const DUTY_SERVER = process.env.VUE_APP_DUTY_SERVER;

const WORKFLOW_SERVER = process.env.VUE_APP_WORKFLOW_SERVER;

const ENTRANCE_GUARD_SERVER = process.env.VUE_APP_ENTRANCEGUARD_SERVER;

const ORGANIZATION_SERVER = process.env.VUE_APP_ORGANIZATION_SERVER;

const COMMON_SERVER = process.env.VUE_APP_COMMON_SERVER;

const NOTICE_SERVER = process.env.VUE_APP_NOTICE_SERVER;

const TICKET_SERVER = process.env.VUE_APP_TICKET_SERVER;

const RELIABLE_SERVER = process.env.VUE_APP_RELIABLE_SERVER;

const RELATION_SERVER = process.env.VUE_APP_RELATION_SERVER;

const FAILURE_SERVER = process.env.VUE_APP_FAILURE_SERVER;

const DCIM_SERVER = process.env.VUE_APP_DCIM_SERVER;

const GRAPH_SERVER = process.env.VUE_APP_GRAPH_SERVER;

const NOTIFICATIONS_SERVER = process.env.VUE_APP_NOTIFICATIONS_SERVER;

export {

    WORK_ORDER_SERVER,

    KNOWLEDGE_SERVER,

    ORGANIZATION_WEB_API_SERVER,

    SERVICE_IP_PORT, RESOURCE_IP_PORT, BASEPATH,

    EQUIPMENT_IN_OUT_SERVER,

    KPI_SERVER,

    ASSESSMENT_SERVER,

    ATTACHMENT_SERVER,

    ATHUB_CLOUD_SERVER,

    PUE_SERVER,
    BILLING_SERVER,

    AUTOKEY_SERVER,

    COMPANY_SERVER,

    DOMAINALN_SERVER,

    PERSON_SERVER,
    ASSET_SERVER,
    REVIEW_SERVER,
    DUTY_SERVER,

    WORKFLOW_SERVER,

    ENTRANCE_GUARD_SERVER,

    ORGANIZATION_SERVER,

    COMMON_SERVER,

    NOTICE_SERVER,

    TICKET_SERVER,

    RELIABLE_SERVER,

    RELATION_SERVER,

    FAILURE_SERVER,

    DCIM_SERVER,
    GRAPH_SERVER,

    NOTIFICATIONS_SERVER,
}
